let menu = [
  {
    name: '统计图表',
    index: '1',
    icon: 'shujutu',
    size: '1.6em',
    margin: '0 2px 6px 4px',
    path: 'DashBoard',
    component: () => import('../components/menu/DashBoard/DashBoard'),
    hidden: true,
    meta: {type0: true, type1: true},
    children: [
      {
        index: '/navmenu/DashBoard/client',
        name: '用户',
        path: 'client',
        component: () => import('../components/menu/DashBoard/children/DBClient')
      },
      {
        index: '/navmenu/DashBoard/seller',
        name: '团长',
        path: 'seller',
        component: () => import('../components/menu/DashBoard/children/DBSeller')
      },
      {
        index: '/navmenu/DashBoard/bot',
        name: '机器人',
        path: 'bot',
        component: () => import('../components/menu/DashBoard/children/DBBot')
      },
      {
        index: '/navmenu/DashBoard/income',
        name: '交易额',
        path: 'income',
        component: () => import('../components/menu/DashBoard/children/DBIncome')
      },
      {
        index: '/navmenu/DashBoard/groupbuy',
        name: '接龙',
        path: 'groupbuy',
        component: () => import('../components/menu/DashBoard/children/DBGroupBuy')
      }
    ]
  },
  {
    name: '品牌商管理',
    index: '/navmenu/brander-list',
    icon: 'qizhi',
    path: 'brander-list',
    hidden: true,
    size: '1.8em',
    margin: '0 0 0 3px',
    meta: {type0: true, type1: true, keepAlive: true},
    component: () => import('../components/menu/BranderList/BranderList')
  },
  {
    name: '外卖团长管理',
    index: '/navmenu/takeaway-list',
    icon: 'qizhi',
    path: 'takeaway-list',
    hidden: true,
    size: '1.8em',
    margin: '0 0 0 3px',
    meta: {type0: true, type1: true, keepAlive: true},
    component: () => import('../components/menu/TakeawayList/TakeawayList')
  },
  {
    name: '代理商管理',
    index: '/navmenu/agent-list',
    icon: 'dailishang',
    path: 'agent-list',
    hidden: true,
    size: '1.5em',
    margin: '0 0 0 3px',
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/AgentList/AgentList')
  },
  {
    name: '统计',
    index: '/navmenu/statistics',
    icon: 'qizhi',
    path: 'statistics',
    hidden: true,
    size: '1.8em',
    margin: '0 0 0 3px',
    meta: {type0: true, type1: true, keepAlive: true},
    component: () => import('../components/menu/Statistics/Statistics')
  },
  {
    name: '用户详情',
    index: '/navmenu/client',
    icon: 'mubiao',
    path: 'client',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/ClientList/ClientList')
  },
  {
    name: '机器人详情',
    index: '/navmenu/BotList',
    icon: 'jiqiren',
    size: '1.7em',
    margin: '0 0 0 3px',
    path: 'BotList',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/BotList/BotList')
  },
  {
    name: '接龙详情',
    index: '/navmenu/groupbuy',
    icon: 'gouwuche',
    path: 'groupbuy',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/GroupBuy/GroupBuy')
  },
  {
    name: '商品排行',
    index: '/navmenu/goods-rank',
    icon: 'paihangbang',
    path: 'goods-rank',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/GoodsRank')
  },
  {
    name: '提现申请',
    index: '/navmenu/paycheck',
    icon: 'qianbao',
    path: 'paycheck',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/PayCheck/PayCheck')
  },
  {
    name: '选货平台',
    index: '',
    icon: 'shenpi',
    size: '1.7em',
    margin: '0 0 0 5px',
    path: 'GoodPlatform',
    component: () => import('../components/menu/GoodPlatform/GoodPlatform'),
    children: [
      {
        index: '/navmenu/GoodPlatform/good-join',
        name: '品牌商上货申请',
        path: 'good-join',
        hidden: true,
        meta: {type0: true, type1: true},
        component: () => import('../components/menu/GoodPlatform/children/GoodJoin')
      },
      {
        index: '/navmenu/GoodPlatform/new-good',
        name: '商品上新',
        path: 'new-good',
        component: () => import('../components/menu/GoodPlatform/children/NewGood')
      },
      {
        index: '/navmenu/GoodPlatform/good-list',
        name: ' 商品列表',
        path: 'good-list',
        meta: {keepAlive: true},
        component: () => import('../components/menu/GoodPlatform/children/GoodList')
      },
      {
        path: 'good-detail',
        name: 'GoodDetail',
        component: () => import('../components/menu/GoodPlatform/children/GoodDetail')
      },
      {
        path: 'goods-edit',
        name: 'GoodsEdit',
        component: () => import('../components/menu/GoodPlatform/children/GoodsEdit')
      },
      {
        name: 'client-regiment',
        path: 'regiment/:client_id',
        component: () => import('../components/menu/ClientList/ClientRegiment')
      },
      {
        index: '/navmenu/GoodPlatform/refund-order',
        name: '退货订单',
        path: 'refund-order',
        component: () => import('../components/menu/GoodPlatform/children/RefundOrder')
      }
    ]
  },
  {
    name: '企业订餐管理',
    index: '/navmenu/business-user',
    icon: 'qiye',
    path: 'business-user',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/BusinessUser/BusinessUser')
  },
  {
    name: '团长/品牌商注册申请',
    index: '/navmenu/become-paying-user',
    icon: 'yanshi',
    path: 'become-paying-user',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/BecomePayingUser/BecomePayingUser')
  },
  {
    name: '大厦推广员',
    index: '/navmenu/building-promoter',
    icon: 'yanshi',
    path: 'building-promoter',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/BuildingPromoter/BuildingPromoter')
  },
  {
    name: '短信跳转',
    index: '/navmenu/message-jump',
    icon: 'qiye',
    path: 'message-jump',
    hidden: true,
    meta: {type0: true, type1: true},
    component: () => import('../components/menu/MessageJump/MessageJump')
  }
]

export default menu
